
/*
    generic functions without the use of parent class.

    imported with {} from this file
*/


//checks if data is not empty
export function isEmpty(data) {
    return (data === undefined || data === "" || data === null);
}

//returns a clone NOTE cannot handle arrays
export function cloneObject(obj) {
    var clone = {};
    for (var i in obj) {
        if (obj[i] !== null && typeof (obj[i]) === "object") {
            clone[i] = cloneObject(obj[i]);
        }
        else {
            clone[i] = obj[i];
        }
    }
    return clone;
}


//copies an array object 
export function copyArrObject(arr) {
    var clone = [];
    for (var i in arr) {
        if (arr[i] !== null && typeof (arr[i]) === "object") {
            clone.push(cloneObject(arr[i]));
        }
        else {
            clone.push(cloneObject(arr[i]));
        }
    }
    return clone;
}

//remove element from the array
export function removeObjectFromArray(element, array) {
    const index = array.indexOf(element);
    if (index !== -1) {
        array.splice(index, 1);
    }
}

/*
    note this does not include file uploads
    and requires
     $postData = json_decode(file_get_contents('php://input'), true); 
*/
export function debug_api_fetch(url) {

    var post_data = {
    }
        
    fetch(url, {
        method: "POST",
        body: JSON.stringify(post_data),
        headers: { 'Content-Type': 'application/json; charset=utf-8' }
    }).then((response) => {
        var responseHttpCode = response.status;
        //good request
        if (responseHttpCode === 200) {
        }
        //bad request
        else {
            //closes loading icon on finish api
            this.setState({
                fetchApiInProgress: false
            })

            this.props.openCariModal({
                modalId: "errorModal",
                title: "Bad Request, please try again.",
            });
        }
        return response.json();
    }).then(json => {
        //successfully processed request
        if (!isEmpty(json)
            && !isEmpty(json.status)
            && json.status
            && !isEmpty(json.message)
        ) {

            //good do stuff
        }
        //if api returns no data
        else {
            //failed no data
        }
    })
    //if api is not found
    .catch((error) => {
        console.log(error);
    })
}



/*
    requires
   $postData = $this->input->post(null, true);
*/
export function api_fetch(url) {

    var form_data = new FormData();

    //form_data.append("something": something);

    //post request to verify email
    fetch(url, {
        method: 'POST',
        body: form_data,
        headers: {
            'Accept': 'application/json',
        }
    }).then((response) => {
        var responseHttpCode = response.status;
        //good request
        if (responseHttpCode === 200) {
        }
        //bad request
        else {
            //closes loading icon on finish api
            this.setState({
                fetchApiInProgress: false
            })

            this.props.openCariModal({
                modalId: "errorModal",
                title: "Bad Request, please try again.",
            });
        }
        return response.json();
    }).then(json => {
        //successfully processed request
        if (!isEmpty(json)
            && !isEmpty(json.status)
            && json.status
            && !isEmpty(json.message)
        ) {

            //good do stuff
        }
        //if api returns no data
        else {
            //failed no data
        }
    })
    //if api is not found
    .catch((error) => {
        console.log(error);
    })
}

/*
    reusable outage banner fetch for CARI views

    return data {
        outageMessages: ["message 1", "message 2"]
    }
*/
export function fetchCariOutageMessages(url) {
    return fetch(url, {
        method: 'POST',
        body: new FormData(),
        headers: {
            'Accept': 'application/json',
        }
    }).then((response) => {
        if (response.status === 200) {
            return response.json();
        }

        return null;
    }).then((json) => {
        if (isEmpty(json)
            || isEmpty(json.status)
            || !json.status
            || isEmpty(json.message)
        ) {
            return [];
        }

        var fetchedMessage = json.message;

        if (typeof fetchedMessage === "string") {
            try {
                fetchedMessage = JSON.parse(fetchedMessage);
            }
            catch (error) {
                fetchedMessage = {
                    outageBanner: fetchedMessage,
                };
            }
        }

        if (isEmpty(fetchedMessage)) {
            return [];
        }

        if (typeof fetchedMessage === "string") {
            return [fetchedMessage];
        }

        if (!isEmpty(fetchedMessage.outageBanners)) {
            return Array.isArray(fetchedMessage.outageBanners)
                ? fetchedMessage.outageBanners
                : [fetchedMessage.outageBanners];
        }

        if (!isEmpty(fetchedMessage.outageBanner)) {
            return Array.isArray(fetchedMessage.outageBanner)
                ? fetchedMessage.outageBanner
                : [fetchedMessage.outageBanner];
        }

        return [];
    });
}